import { render } from "./CardFileList.vue?vue&type=template&id=22d8aa71&scoped=true"
import script from "./CardFileList.vue?vue&type=script&lang=js"
export * from "./CardFileList.vue?vue&type=script&lang=js"

import "./CardFileList.vue?vue&type=style&index=0&id=22d8aa71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d8aa71"]])

export default __exports__